// src/components/PageTransitionLoader.jsx
'use client'

import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Loader from './Loader'

export default function PageTransitionLoader() {
  const location = useLocation()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)

    const timeout = setTimeout(() => {
      setLoading(false)
    }, 600) // matches fade-out duration

    return () => clearTimeout(timeout)
  }, [location.pathname])

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-white dark:bg-zinc-900 transition-opacity duration-500 pointer-events-none ${
        loading ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <Loader />
    </div>
  )
}
